import { UserResetPasswordComponent } from '../user-reset-password/user-reset-password.component';
import { Component, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'app-user-forgot-password-view',
  templateUrl: './user-forgot-password-view.component.html',
  styleUrls: ['./user-forgot-password-view.component.scss']
})
export class UserForgotPasswordViewComponent implements OnInit {
  verificationCode: string;
  newPassword: string;

  constructor(private dialogRef: NbDialogRef<UserForgotPasswordViewComponent>) { }

  ngOnInit() {
  }

  closeWithData() {
    const reset = {
      verificationCode: this.verificationCode,
      newPassword: this.newPassword
    };
    this.dialogRef.close(reset);
  }

  close() {
    this.dialogRef.close();
  }

}
